export default "__VITE_ASSET__CMc_9z48__"